// 服务商类型
export const SERVICE_TYPES = {
  carProvider: {
    name: '车源方',
    value: '0',
  },
  insuranceCompany: {
    name: '保险公司',
    value: '2',
  },
  propertyOwner: {
    name: '产权方',
    value: '3',
  },
}

// 采购方式
export const PURCHASE_TYPES = {
  purchase: {
    name: '购买',
    value: 1,
  },
  rent: {
    name: '租用',
    value: 2,
  },
}
export const PURCHASE_TYPE_LIST = Object.values(PURCHASE_TYPES)

// 证件类型
export const LICENSE_TYPES = {
  // 行驶证主页
  drivingLicenseMain: {
    name: '行驶证主页',
    value: 30,
  },
  // 行驶证副页
  drivingLicenseBack: {
    name: '行驶证副页',
    value: 33,
  },
  // 登记证
  carRegistCertLicense: {
    name: '登记证照片',
    value: 31,
  },
  // 网约车证
  carTransportLicense: {
    name: '网约车证照片',
    value: 32,
  },
}
export const LICENSE_TYPE_LIST = Object.values(LICENSE_TYPES)

// 保险类型
export const INSURANCE_TYPE_LIST = [
  {
    name: '交强险',
    value: 1,
    uploadType: 53,
  },
  {
    name: '商业险',
    value: 2,
    uploadType: 54,
  },
  {
    name: '承运人责任险',
    value: 3,
    uploadType: 55,
  },
  {
    name: '客伤险',
    value: 4,
    uploadType: 56,
  },
  {
    name: '车船税',
    value: 5,
    uploadType: 57,
  },
  {
    name: '盗抢险',
    value: 6,
    uploadType: 58,
  },
]

// 保单附件命名方式
export const INSURANCE_ATTACHMENT_NAME_TYPE_LIST = [
  {
    name: '保单号命名',
    value: 1,
  },
  {
    name: '车牌号命名',
    value: 2,
  },
  {
    name: 'VIN命名',
    value: 3,
  },
]

// OCR提示文案
export const OCR_TIPS = '，提交证照后会更新证照相关车辆信息。'
// OCR识别次数上限提示文案
export const OCR_LIMIT_TIPS = '当月OCR识别已达使用次数上限，具体请联系运营同学'
// 证照压缩包提示文案
export const LICENSE_ZIP_TIPS = '请将以车牌号命名的证件照片放在一个文件夹中，将文件夹进行压缩后上传。'
// 保单附件压缩包提示文案
export const LICENSE_ATTACHMENT_ZIP_TIPS = '支持按照车牌号/保单号/VIN命名车辆的保单附件。上传后，将会新增或更新车辆的保单附件信息。上传文件仅支持压缩包格式进行上传，文件支持pdf和图片格式。'

// 批量录入车辆模板链接
export const BATCH_IMPORT_CAR_TEMPLATE = 'https://server-resource-v4.cheweijia.com/public/common_for_test_file/cd8fb5d1079641678159ed7ec793d54b/1ac0bb6ff7ca4aedb1d7caadf9565734.xlsx'
// 批量确认到库模板链接
export const BATCH_IMPORT_IN_STOCK_TEMPLATE = 'https://server-resource-v4.cheweijia.com/public/common_for_default_file/0d34c6ff7aa841108d2c7b3412c3fcf6/批量到库模板v2.xlsx'
// 批量录入保单模板链接
export const BATCH_IMPORT_INSURANCE_POLICY_TEMPLATE = 'https://server-resource-v4.cheweijia.com/public/assets/templates/jaguar/%E4%BF%9D%E5%8D%95%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88v4.xlsx'


export const LICENSE_TIPS = [
  '1、将图片放在同一个文件夹中打包为zip文件，压缩包最大上传200M。',
  '2、登记证最多可上传9张，图片名按“车牌号_01”命名，如京A123456_01、京A123456_02。',
  '3、车牌号_01默认为登记证主页，车牌号_02后边的序号默认为登记证副页。',
  '4、点击【X】/【取消】按钮，文件取消上传。',
]

export const LICENSE_CARD_TIPS = [
  '1、请将以车牌号命名的证件照片放在一个文件夹中，将文件夹压缩为zip文件后上传，压缩包最大上传200M。',
  '2、点击【X】/【取消】按钮，文件取消上传。',
]
